import { useMemo } from 'react';
import useBooleanArray from './array/useBoolean';
export function useBoolean(initial) {
    const [value, actions] = useBooleanArray(initial);
    return useMemo(() => (Object.assign({ value }, actions)), [actions, value]);
}
export default useBoolean;
//# sourceMappingURL=useBoolean.js.map